import { render, staticRenderFns } from "./Peminatan.vue?vue&type=template&id=314740d7"
import script from "./Peminatan.vue?vue&type=script&lang=js"
export * from "./Peminatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports